import {Button, ButtonGroup, closeCurrentDialog} from 'platform/components';
import {Space, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {NeededAtDecision} from '../types/NeededAtDecision';

interface NeededAtConfirmationDialogProps extends RequiredTestIdProps {
  onDecision: (_decision: NeededAtDecision) => void;
}

export function NeededAtConfirmationDialog(props: NeededAtConfirmationDialogProps) {
  const handleDecision = (decision: NeededAtDecision) => () => {
    props.onDecision(decision);
    closeCurrentDialog();
  };

  return (
    <>
      <Text alternative>{i18n.t('page.warehouse.labels.updateNeededAtDateOnExistingItems')}</Text>
      <Space vertical={2} />
      <ButtonGroup align="right" data-testid={suffixTestId('confirmDialog', props)}>
        <Button
          data-testid={suffixTestId('confirmDialog-cancel', props)}
          title={i18n.t('general.actions.cancel')}
          variant="secondary"
          onClick={handleDecision('cancel')}
        />
        <Button
          data-testid={suffixTestId('confirmDialog-dontUpdate', props)}
          title={i18n.t('entity.orderRequest.actions.dontUpdate')}
          variant="secondary"
          onClick={handleDecision('dontUpdate')}
        />
        <Button
          data-testid={suffixTestId('confirmDialog-update', props)}
          title={i18n.t('general.actions.update')}
          variant="primary"
          onClick={handleDecision('update')}
        />
      </ButtonGroup>
    </>
  );
}
